import type { RouteObject } from 'react-router';
import { ShipmentsPage } from './ShipmentsPage';
import { ShipmentDetailPage } from './ShipmentDetailPage';

/** path 相对 /v2。批次详情的参数是批次号（老系统没有按 id 取批次的接口） */
export const routes: RouteObject[] = [
  { path: 'shipments', element: <ShipmentsPage /> },
  { path: 'shipments/:no', element: <ShipmentDetailPage /> },
];
